



import PProgress from 'p-progress';
import { IWorkspaceDB } from '../../interface/db';
import IBaseDto from '../../model/private/IBaseDto';

import sitePatchMap from './private/sitePatchMap';

function _promise(db: IWorkspaceDB, patchPath: string, items: [IBaseDto]): Promise<void> {
    if ( patchPath === 'hash') { return Promise.resolve(); }

    const entityName = sitePatchMap.entityNameFromPatchPath(patchPath) ?? patchPath;
    const interfaceName = sitePatchMap.interfaceNameFromEntityName(entityName);
    const tableName = sitePatchMap.tableNameFromInterfaceName(interfaceName);

    let promise = Promise.resolve();

    if ( tableName ) {
        promise = db.getTable(tableName).bulkAddOrUpdate(items);
    } else {
        console.error(`Unable to find table name for entity: ${patchPath}`);
    }

    return promise;
}

function update(db: IWorkspaceDB, source: Record<string,IBaseDto|[IBaseDto]> = {}): PProgress<void>  {
    return new PProgress(async function(resolve, reject, progress) {
        try {
            const patchPaths = Object.keys(source);
            const progressPerPath = 1.0 / patchPaths.length;

            for ( let i=0; i<patchPaths.length; i++ ) {
                const patchPath = patchPaths[i];
                let items = source[patchPath];
        
                /* '/site' comes back as an Object, not an array. make sure all added are arrays */
                if ( !Array.isArray(items) ) {
                    items = [items];
                }

                const promise = _promise(db, patchPath, items);

                await promise;

                progress(i * progressPerPath);
            }

            resolve();
        } catch (error) {
            reject(error);
        }
    });
}

export default update;